/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PromotionCampaignPrizeAmount } from './PromotionCampaignPrizeAmount';
import {
    PromotionCampaignPrizeAmountFromJSON,
    PromotionCampaignPrizeAmountFromJSONTyped,
    PromotionCampaignPrizeAmountToJSON,
} from './PromotionCampaignPrizeAmount';

/**
 * Plugin-specific configuration
 * @export
 * @interface PromotionCampaignAwardConfig
 */
export interface PromotionCampaignAwardConfig {
    [key: string]: any | any;
    /**
     * 
     * @type {PromotionCampaignPrizeAmount}
     * @memberof PromotionCampaignAwardConfig
     */
    amount?: PromotionCampaignPrizeAmount;
}

/**
 * Check if a given object implements the PromotionCampaignAwardConfig interface.
 */
export function instanceOfPromotionCampaignAwardConfig(value: object): value is PromotionCampaignAwardConfig {
    return true;
}

export function PromotionCampaignAwardConfigFromJSON(json: any): PromotionCampaignAwardConfig {
    return PromotionCampaignAwardConfigFromJSONTyped(json, false);
}

export function PromotionCampaignAwardConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): PromotionCampaignAwardConfig {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'amount': json['amount'] == null ? undefined : PromotionCampaignPrizeAmountFromJSON(json['amount']),
    };
}

export function PromotionCampaignAwardConfigToJSON(value?: PromotionCampaignAwardConfig | null): any {
    if (value == null) {
        return value;
    }
    return {
        
            ...value,
        'amount': PromotionCampaignPrizeAmountToJSON(value['amount']),
    };
}

